import moment from "moment";
import React, { useState, useEffect, useRef } from "react";
import { Row, Form, Button, Modal, Col, FormControl, Spinner } from "react-bootstrap";
import DayPickerInput from "react-day-picker/DayPickerInput";
import CustomItineraryUnit from "../../../Data/Reservation/Custom/CustomItineraryUnit";
import GolfItineraryUnit from "../../../Data/Reservation/Golf/GolfItineraryUnit";
import LodgingItineraryUnit from "../../../Data/Reservation/Lodging/LodgingItineraryUnit";
import Reservation from "../../../Data/Reservation/Reservation";
import TransportItineraryUnit from "../../../Data/Reservation/Transportation/TransportItineraryUnit";
import UseGetCustomVendors from "../start-widget/widget/widget-modals/custom/add-custom/data-service-hooks/UseGetCustomVendors";
import useGetVendorConfirmationReservation, { GetVendorConfirmationReservationRequest } from "./UseGetVendorConfirmationReservation";
import useUpdateItineraryUnitConfirmationNumber from "./UseUpdateItineraryConfirmation";
import momentJs from "react-day-picker/moment";
import UnitRate from "../../../Data/Rates/UnitRate";
import EnumProductRateType from "../../../Data/Rates/EnumProductRateType";
import VendorReservation from "../../../Data/Reservation/VendorReservation";
import { toast } from "react-toastify";
import { isNullOrUndefined } from "util";
import { isStringEmpty } from "../../../_helpers/Functions";
import CustomDayPickerInput from "../customDayPickerInput/CustomDayPickerInput";
import { TimeOption } from "../../../_helpers/Types";

interface Props {
  startWidgetId: number;
  itineraryNumber: string;
  vendorGuid: string;
}

const VendorConfirmation: React.FC<Props> = (props) => {
  const queryString = window.location.href;
  const urlParams = new URLSearchParams(queryString);

  const idParam = urlParams.get("id");
  const itineraryNumber = urlParams.get("itineraryNumber");
  const vendorParam = urlParams.get("vendorId");

  const [vendorReservation, setVendorReservation] = useState<VendorReservation>();
  const [vendorReservationRequest, setVendorReservationRequest] = useState<GetVendorConfirmationReservationRequest>();
  const vendorConfirmationResponse = useGetVendorConfirmationReservation(vendorReservationRequest);

  const [lodgingUnits, setLodgingUnits] = useState<any[]>([]);
  const [golfUnits, setGolfUnits] = useState<any[]>([]);
  const [transportUnits, setTransportUnits] = useState<any[]>([]);
  const [customUnits, setCustomUnits] = useState<any[]>([]);
  const [vendorName, setVendorName] = useState<string>();

  const [obj, setObj] = useState<any>();
  const updateResponse = useUpdateItineraryUnitConfirmationNumber(obj);

  const { formatDate, parseDate } = momentJs;

  const [teeTimes, setTeeTimes] = useState<TimeOption[]>([]);
  const teeTimesOptions = teeTimes.map((teeTime: TimeOption, index: number) => (
    <option value={teeTime.value} key={index}>{teeTime.label}</option>
  ));

  const [startTimes, setStartTimes] = useState<TimeOption[]>([]);
  const startTimeOptions = startTimes.map((time: TimeOption, index: number) => (
    <option value={time.value} key={index}>{time.label}</option>
  ));

  const [errors, setErrors] = useState<any>({});

  function checkInDateChanged(index: number, date: Date) {
    lodgingUnits[index].checkIn = moment(date).format("YYYY-MM-DD");
    setLodgingUnits([...lodgingUnits]);
  }

  function checkOutDateChanged(index: number, date: Date) {
    lodgingUnits[index].checkOut = moment(date).format("YYYY-MM-DD");
    setLodgingUnits([...lodgingUnits]);
  }

  function playDateChanged(index: number, date: Date) {
    golfUnits[index].playDate = moment(date).format("YYYY-MM-DD");
    setGolfUnits([...golfUnits]);
  }

  function teeTimeChanged(index: number, time: string) {
    golfUnits[index].teeTime = time;
    setGolfUnits([...golfUnits]);
  }

  function startDateChanged(type: string, index: number, date: Date) {
    if (type === "transport") {
      transportUnits[index].startDate = moment(date).format("YYYY-MM-DD");
      setTransportUnits([...transportUnits]);
    }
    else if (type === "custom") {
      customUnits[index].fromDate = moment(date).format("YYYY-MM-DD");
      setCustomUnits([...customUnits]);
    }
  }

  function endDateChanged(type: string, index: number, date: Date) {
    if (type === "transport") {
      transportUnits[index].endDate = moment(date).format("YYYY-MM-DD");
      setTransportUnits([...transportUnits]);
    }
    else if (type === "custom") {
      customUnits[index].toDate = moment(date).format("YYYY-MM-DD");
      setCustomUnits([...customUnits]);
    }
  }

  function startTimeChanged(type: string, index: number, time: string) {
    if (type === "transport") {
      transportUnits[index].startTime = time;
      setTransportUnits([...transportUnits]);
    }
    else if (type === "custom") {
      customUnits[index].startTime = time;
      setCustomUnits([...customUnits]);
    }
  }

  function endTimeChanged(type: string, index: number, time: string) {
    if (type === "transport") {
      transportUnits[index].endTime = time;
      setTransportUnits([...transportUnits]);
    }
    else if (type === "custom") {
      customUnits[index].endTime = time;
      setCustomUnits([...customUnits]);
    }
  }

  function unitsChanged(type: string, index: number, units: number) {
    if (type === "transport") {
      transportUnits[index].units = units;
      setTransportUnits([...transportUnits]);
    }
    else if (type === "custom") {
      customUnits[index].units = units;
      setCustomUnits([...customUnits]);
    }
  }

  function golfConfirmedTimeChanged(index: number, time: string) {
    golfUnits[index].unit.confirmedTime = time;
    setGolfUnits([...golfUnits]);
  }

  function populateTeeTimes() {
    // Set the tee times.
    let rateTeeTimes: TimeOption[] = [];
    let start = moment("00:00", 'HH:mm');
    let end = moment("23:50", 'HH:mm');
    let current = moment(start);
    while (current <= end) {
      rateTeeTimes.push({
        value: current.format('HH:mm'),
        label: current.format('hh:mm a'),
        foreUpTeeTimeId: "",
        golfNowTeeTimeId: "",
        lightSpeedTeeTimeId: "",
        openSpots: 0,
        price: 0,
        isLive: false,
        vendorUnitId: 0,
        productRateId: 0
      });
      current.add(10, 'minutes');
    }

    setTeeTimes(rateTeeTimes);
  }

  function populateStartTimes() {
    // Set the tee times.
    let rateTeeTimes: TimeOption[] = [];
    let start = moment("00:00", 'HH:mm');
    let end = moment("23:00", 'HH:mm');
    let current = moment(start);
    while (current <= end) {
      rateTeeTimes.push({
        value: current.format('HH:mm'),
        label: current.format('hh:mm a'),
        foreUpTeeTimeId: "",
        golfNowTeeTimeId: "",
        lightSpeedTeeTimeId: "",
        openSpots: 0,
        price: 0,
        isLive: false,
        vendorUnitId: 0,
        productRateId: 0
      });
      current.add(60, 'minutes');
    }

    setStartTimes(rateTeeTimes);
  }

  function getNumUnitsOptions(): JSX.Element[] {
    const options: JSX.Element[] = [];

    for (let index = 0; index < (!!vendorReservation ? vendorReservation.numGuests : 2); index++) {
      options.push(<option key={`units option ${index}`}>{index + 1}</option>);
    }

    return options;
  }

  function onSubmit(type: string, unit: any) {
    if (type === "lodging") {
      if (isStringEmpty(unit.confirmationNumber)) {
        setErrors({ unit });
      } else {
        setErrors({});
        setObj({
          itineraryUnitId: unit.id,
          checkIn: unit.checkIn,
          checkOut: unit.checkOut,
          confirmationNumber: unit.confirmationNumber,
          itineraryType: type
        });
      }
    }
    else if (type === "golf") {
      if (isStringEmpty(unit.confirmationNumber)) {
        setErrors({ unit });
      } else {
        setErrors({});
        setObj({
          itineraryUnitId: unit.id,
          playDate: unit.playDate,
          teeTime: unit.teeTime,
          confirmationNumber: unit.confirmationNumber,
          confirmedTime: unit.confirmedTime,
          itineraryType: type
        });
      }
    }
    else if (type === "transport") {
      if (isStringEmpty(unit.confirmationNumber)) {
        setErrors({ unit });
      } else {
        setErrors({});
        setObj({
          itineraryUnitId: unit.id,
          startDate: unit.startDate,
          endDate: unit.endDate,
          startTime: unit.startTime,
          endTime: unit.endTime,
          units: unit.units,
          confirmationNumber: unit.confirmationNumber,
          itineraryType: type
        });
      }
    }
    else if (type === "custom") {
      if (isStringEmpty(unit.confirmationNumber)) {
        setErrors({ unit });
      } else {
        setErrors({});
        setObj({
          itineraryUnitId: unit.id,
          fromDate: unit.fromDate,
          toDate: unit.toDate,
          fromTime: unit.fromTime,
          toTime: unit.toTime,
          units: unit.units,
          confirmationNumber: unit.confirmationNumber,
          itineraryType: type
        });
      }
    }
  }

  useEffect(() => {
    populateTeeTimes();
    populateStartTimes();
  }, []);

  useEffect(() => {
    if (itineraryNumber === null || vendorParam === null) return;

    setVendorReservationRequest({ itineraryNumber, vendorId: vendorParam });
  }, []);

  useEffect(() => {
    if (updateResponse.data === null) return;

    toast.success('Itinerary Updated!', { hideProgressBar: true });
  }, [updateResponse.data]);

  useEffect(() => {
    // listen for reservation response
    if (vendorConfirmationResponse.data === null) return;

    setVendorReservation(vendorConfirmationResponse.data.reservation);
  }, [vendorConfirmationResponse.data]);

  useEffect(() => {
    if (vendorReservation === undefined) return;

    vendorReservation.lodgingItineraries.forEach((li: any) => {
      li.itineraryUnits.forEach((unit: any) => {
        if (!unit.cancelled)
          lodgingUnits.push({ unit: unit, vendorName: li.vendorName });
        setVendorName(li.vendorName);
      })
    });

    vendorReservation.golfItineraries.forEach((gi: any) => {
      gi.itineraryUnits.forEach((unit: any) => {
        if (!unit.cancelled)
          golfUnits.push({ unit: unit, vendorName: gi.vendorName });
        setVendorName(gi.vendorName);
      })
    });

    vendorReservation.transportItineraries.forEach((ti: any) => {
      ti.itineraryUnits.forEach((unit: any) => {
        if (!unit.cancelled)
          transportUnits.push({ unit: unit, vendorName: ti.vendorName });
        setVendorName(ti.vendorName);
      })
    });

    vendorReservation.customItineraries.forEach((ci: any) => {
      ci.itineraryUnits.forEach((unit: any) => {
        if (!unit.cancelled)
          customUnits.push({ unit: unit, vendorName: ci.vendorName });
        setVendorName(ci.vendorName);
      })
    });
  }, [vendorReservation]);

  return (
    <div>
      {vendorConfirmationResponse.isLoading && (
        <span><Spinner
          as="span"
          animation="border"
          size="sm"
          role="status"
          aria-hidden="true"
        /> Loading...</span>
      )}
      {!vendorConfirmationResponse.isLoading && (
        <Form>
          <Col xs={12}>
            {vendorReservation !== undefined && vendorReservation.brand !== undefined && (
              <p className="m-0 p-0 mb-3 font-weight-bold" style={{ fontSize: "18px" }}>Automated Booking Link From: {vendorReservation.brand.companyName}</p>
            )}
            <p className="m-0 p-0 mb-3 font-weight-bold red-text" style={{ fontSize: "18px" }}>Step 1. <span className="red-text" style={{ fontStyle: "italic", fontWeight: "normal" }}>
              Carefully review the details below and enter exact tee time, confirmation or reference number into the fields.
            </span></p>
            <p className="m-0 p-0 mb-3 font-weight-bold red-text" style={{ fontSize: "18px" }}>Step 2. <span className="red-text" style={{ fontStyle: "italic", fontWeight: "normal" }}>
              Please confirm the NET rate to be billed to {vendorReservation !== undefined && vendorReservation.brand !== undefined && (
                <span>{vendorReservation.brand.companyName}.</span>
              )}
            </span></p>
            <p className="m-0 p-0 mb-3 font-weight-bold red-text" style={{ fontSize: "18px" }}>Step 3. <span className="red-text" style={{ fontStyle: "italic", fontWeight: "normal" }}>
              Press save & wait for the confirmation message.
            </span></p>

            <p className="m-0 p-0 mb-3 font-weight-bold" style={{ fontSize: "18px" }}>{vendorName}</p>
            {!!vendorReservation && !!vendorReservation.leadCustomer && (
              <p className="m-0 p-0 mb-3 font-weight-bold" style={{ fontSize: "18px" }}>Guest Name: <span className="red-text">{`${vendorReservation.leadCustomer.firstName} ${vendorReservation.leadCustomer.lastName}`}</span></p>
            )}

            <Row>
              {lodgingUnits !== undefined && lodgingUnits.map((item: any, index: number) =>
                <>
                  <Col xs={12} md={6}>
                    <div className="mb-3">
                      <p className="m-0 p-0 mb-3 font-weight-bold" style={{ fontSize: "18px" }}>Unit Type: <span className="red-text">{item.unit.vendorUnit.unitName}</span></p>
                      <p className="m-0 p-0 mb-3 font-weight-bold" style={{ fontSize: "18px" }}>Net Rate $: <span className="red-text">{item.unit.net}</span></p>

                      <Row className="d-flex flex-row justify-content-start mb-3">
                        <Col xs={3} className="d-flex flex-column">
                          <Form.Label>
                            # of Guests
                          </Form.Label>
                          <Form.Control type="number" className="mb-3"
                            defaultValue={item.unit.guestsInUnit}
                            disabled
                          />
                        </Col>
                        <Col xs={3} className="d-flex flex-column ml-2">
                          <Form.Label>
                            # of Units
                          </Form.Label>
                          <Form.Control type="number" className="mb-3"
                            defaultValue={item.unit.numberOfUnits}
                            disabled
                          />
                        </Col>
                      </Row>

                      <Row className="d-flex flex-row justify-content-start mb-3">
                        <div className="d-flex flex-column InputFromTo">
                          <Form.Label>
                            Arrive
                          </Form.Label>
                          <CustomDayPickerInput
                            // overlayComponent={MobileDayPickerOverlay}
                            value={moment(item.unit.checkIn).format("ddd, MMM Do, YYYY")}
                            placeholder="From"
                            format="LL"
                            formatDate={formatDate}
                            parseDate={parseDate}
                            inputProps={{ disabled: true }}
                            dayPickerProps={{
                              selectedDays: [item.unit.checkIn],
                              // disabledDays: { before: datesAndGuests.fromDate, after: datesAndGuests.toDate },
                              // toMonth: item.checkOut,
                              // modifiers,
                              numberOfMonths: 1,
                              // onDayClick: () => this.to.getInput().focus(),
                            }}
                            onDayChange={(date: Date) => checkInDateChanged(index, date)}
                          />
                        </div>

                        <div className="d-flex flex-column InputFromTo " style={{ paddingLeft: "10px" }}>
                          <Form.Label>
                            Depart
                          </Form.Label>
                          <CustomDayPickerInput
                            // overlayComponent={MobileDayPickerOverlay}
                            value={moment(item.unit.checkOut).format("ddd, MMM Do, YYYY")}
                            placeholder="Check Out"
                            format="LL"
                            formatDate={formatDate}
                            parseDate={parseDate}
                            inputProps={{ disabled: true }}
                            dayPickerProps={{
                              selectedDays: [item.unit.checkOut],
                              // disabledDays: { before: moment(item.checkIn).toDate(), after: moment(item.checkOut).toDate() },
                              // modifiers,
                              numberOfMonths: 1
                            }}
                            onDayChange={(date: Date) => checkOutDateChanged(index, date)}
                          />
                        </div>
                      </Row>

                      <Form.Group as={Col} xs={12} >
                        <Form.Label>Confirmation Number</Form.Label>
                        <Row>
                          <Col xs={6} className="pr-3">
                            <Form.Control className=""
                              defaultValue={item.unit.confirmationNumber !== undefined ? item.unit.confirmationNumber : ""}
                              onChange={(e: any) => {
                                item.unit.confirmationNumber = e.target.value;
                              }}
                              isInvalid={errors.unit !== undefined && errors.unit.id === item.unit.id}
                            />
                          </Col>
                          <Col xs={2}>
                            <Button variant="success" onClick={
                              () => {
                                onSubmit("lodging", item.unit);
                              }
                            }>{updateResponse.isLoading ? (
                              <span><Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                              /></span>
                            ) : "save"}</Button>
                          </Col>

                        </Row>
                        {/* <Form.Control.Feedback type="invalid">
          {"Required"}
        </Form.Control.Feedback> */}
                      </Form.Group>
                    </div>
                  </Col>
                  <br />
                </>
              )}

              {golfUnits !== undefined && golfUnits.map((item: any, index: number) =>
                <>
                  <Col xs={12} md={6}>
                    <div className="mb-3">
                      <p className="m-0 p-0 mb-3 font-weight-bold" style={{ fontSize: "18px" }}><span className="">{item.unit.vendorUnit.unitName}</span></p>
                      <p className="m-0 p-0 mb-3 font-weight-bold" style={{ fontSize: "18px" }}>Net Rate $: <span className="red-text">{item.unit.net}</span></p>

                      <Row className="d-flex flex-row justify-content-start mb-3">
                        <div className="d-flex flex-column InputFromTo">
                          <Form.Label>
                            Date of Play
                          </Form.Label>
                          <CustomDayPickerInput
                            inputProps={{ disabled: true }}
                            // overlayComponent={MobileDayPickerOverlay}
                            value={moment(item.unit.playDate).format("ddd, MMM Do, YYYY")}
                            placeholder="From"
                            format="LL"
                            formatDate={formatDate}
                            parseDate={parseDate}
                            dayPickerProps={{
                              selectedDays: [item.unit.playDate],
                              // toMonth: item.checkOut,
                              // modifiers,
                              numberOfMonths: 1,
                              // onDayClick: () => this.to.getInput().focus(),
                            }}
                            onDayChange={(date: Date) => playDateChanged(index, date)}
                          />
                        </div>
                        <Col xs={3} className="d-flex flex-column pl-3 pr-3">
                          <Form.Label>
                            # of Players
                          </Form.Label>
                          <Form.Control className=""
                            defaultValue={item.unit.players}
                            disabled
                          // onChange={(e: any) => {
                          //   item.unit.confirmationNumber = e.target.value;
                          // }}
                          />
                        </Col>
                      </Row>

                      <Row className="mb-3">
                        <div className="d-flex flex-column">
                          <Form.Label>
                            Tee Time
                          </Form.Label>
                          <Form.Control
                            disabled
                            as="select"
                            name="teeTime"
                            defaultValue={item.unit.teeTime}
                            className=""
                            onChange={(e: any) => teeTimeChanged(index, e.currentTarget.value)}>
                            {teeTimesOptions}
                          </Form.Control>
                        </div>

                        <div className="d-flex flex-column ml-3">
                          <Form.Label>
                            Confirmed Time
                          </Form.Label>
                          <Form.Control type="time"
                            aria-label="Confirmed Time"
                            name="confirmedTime"
                            id="confirmedTime"
                            defaultValue={item.unit.confirmedTime}
                            onChange={(event: any) => {
                              golfConfirmedTimeChanged(index, event.target.value);
                            }}
                          />
                        </div>
                      </Row>

                      <Form.Group as={Col} xs={12} >
                        <Form.Label>Confirmation Number</Form.Label>
                        <Row>
                          <Col xs={6} className="pr-3">
                            <Form.Control className=""
                              defaultValue={item.unit.confirmationNumber !== undefined ? item.unit.confirmationNumber : ""}
                              onChange={(e: any) => {
                                item.unit.confirmationNumber = e.target.value;
                              }}
                              // isValid={props.validate && props.validateFields.includes(`emailSubject_${props.keyId}`) && !!quoteTemplate.emailSubject}
                              isInvalid={errors.unit !== undefined && errors.unit.id === item.unit.id}
                            />
                          </Col>
                          <Col xs={2}>
                            <Button variant="success" onClick={
                              () => {
                                onSubmit("golf", item.unit);
                              }
                            }>{updateResponse.isLoading ? (
                              <span><Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                              /></span>
                            ) : "save"}</Button>
                          </Col>

                        </Row>
                        {/* <Form.Control.Feedback type="invalid">
          {"Required"}
        </Form.Control.Feedback> */}
                      </Form.Group>

                    </div>
                  </Col>
                  <br />
                </>
              )}

              {transportUnits !== undefined && transportUnits.map((item: any, index: number) => {
                const productType = item.unit.vendorUnit.productRate.productRateTypeId as EnumProductRateType;
                const rangePickerMode = productType == EnumProductRateType.DayRange;
                const isHourlyRate = productType == EnumProductRateType.HoursPerUnit;
                const isUnitRate = productType == EnumProductRateType.UnitQtyRange;
                const isDailyRate = productType == EnumProductRateType.DayRange;

                return (
                  <>
                    <Col xs={12} md={6}>
                      <div className="mb-3">
                        <p className="m-0 p-0 mb-3 font-weight-bold" style={{ fontSize: "18px" }}><span className="">{item.unit.vendorUnit.unitName}</span></p>
                        <p className="m-0 p-0 mb-3 font-weight-bold" style={{ fontSize: "18px" }}>Net Rate $: <span className="red-text">{item.unit.net}</span></p>

                        <Row className="d-flex flex-row justify-content-start mb-3">
                          <div className="d-flex flex-column InputFromTo">
                            <Form.Label>
                              Start Date
                            </Form.Label>
                            <CustomDayPickerInput
                              // overlayComponent={MobileDayPickerOverlay}
                              inputProps={{ disabled: true }}
                              value={moment(item.unit.startDate).format("ddd, MMM Do, YYYY")}
                              placeholder="From"
                              format="LL"
                              formatDate={formatDate}
                              parseDate={parseDate}
                              dayPickerProps={{
                                selectedDays: [item.unit.startDate],
                                // disabledDays: { before: datesAndGuests.fromDate, after: datesAndGuests.toDate },
                                // toMonth: item.checkOut,
                                // modifiers,
                                numberOfMonths: 1,
                                // onDayClick: () => this.to.getInput().focus(),
                              }}
                              onDayChange={(date: Date) => startDateChanged("transport", index, date)}
                            />
                          </div>
                          {rangePickerMode && (
                            <div className="d-flex flex-column InputFromTo " style={{ paddingLeft: "10px" }}>
                              <Form.Label>
                                End Date
                              </Form.Label>
                              <CustomDayPickerInput
                                inputProps={{ disabled: true }}
                                // overlayComponent={MobileDayPickerOverlay}
                                value={moment(item.unit.endDate).format("ddd, MMM Do, YYYY")}
                                placeholder="Check Out"
                                format="LL"
                                formatDate={formatDate}
                                parseDate={parseDate}
                                dayPickerProps={{
                                  selectedDays: [item.unit.endDate],
                                  // disabledDays: { before: moment(item.checkIn).toDate(), after: moment(item.checkOut).toDate() },
                                  // modifiers,
                                  numberOfMonths: 1
                                }}
                                onDayChange={(date: Date) => endDateChanged("transport", index, date)}
                              />
                            </div>
                          )}
                        </Row>
                        <Row className="d-flex flex-row justify-content-start mb-3">
                          <div className="d-flex flex-column">
                            <Form.Label>
                              Start Time
                            </Form.Label>
                            <Form.Control
                              as="select"
                              name="startTime"
                              className="time-select"
                              style={{ width: "120px" }}
                              value={item.unit.startTime}
                              onChange={(event: any) => { startTimeChanged("transport", index, event.currentTarget.value) }}
                            >

                              {startTimeOptions}
                            </Form.Control>
                          </div>

                          {/* To Time Select */}
                          {(isHourlyRate || isDailyRate) && (
                            <div className="d-flex flex-column pl-3">
                              <Form.Label>
                                End Time
                              </Form.Label>
                              <Form.Control
                                as="select"
                                name="endTime"
                                className="time-select"
                                style={{ width: "120px" }}
                                value={item.unit.endTime}
                                onChange={(event: any) => { endTimeChanged("transport", index, event.currentTarget.value) }}
                              >

                                {startTimeOptions}
                              </Form.Control>
                            </div>
                          )}

                          <div className="d-flex flex-column pl-3">
                            <Form.Label>
                              Units
                            </Form.Label>
                            <Form.Control
                              disabled
                              as="select"
                              name="units"
                              className="guest-select"
                              defaultValue={item.unit.units}
                              onChange={(event: any) => { unitsChanged("transport", index, event.currentTarget.value) }}
                            >
                              {getNumUnitsOptions()}
                            </Form.Control>
                          </div>
                        </Row>

                        <Form.Group as={Col} xs={12} >
                          <Form.Label>Confirmation Number</Form.Label>
                          <Row>
                            <Col xs={6} className="pr-3">
                              <Form.Control className=""
                                defaultValue={item.unit.confirmationNumber !== undefined ? item.unit.confirmationNumber : ""}
                                onChange={(e: any) => {
                                  item.unit.confirmationNumber = e.target.value;
                                }}
                                isInvalid={errors.unit !== undefined && errors.unit.id === item.unit.id}
                              />
                            </Col>
                            <Col xs={2}>
                              <Button variant="success" onClick={
                                () => {
                                  onSubmit("transport", item.unit);
                                }
                              }>{updateResponse.isLoading ? (
                                <span><Spinner
                                  as="span"
                                  animation="border"
                                  size="sm"
                                  role="status"
                                  aria-hidden="true"
                                /></span>
                              ) : "save"}</Button>
                            </Col>

                          </Row>
                          {/* <Form.Control.Feedback type="invalid">
          {"Required"}
        </Form.Control.Feedback> */}
                        </Form.Group>
                      </div>
                    </Col>
                    <br />
                  </>
                )
              }
              )}

              {customUnits !== undefined && customUnits.map((item: any, index: number) => {
                const productType = item.unit.vendorUnit.productRate.productRateTypeId as EnumProductRateType;
                const rangePickerMode = productType == EnumProductRateType.DayRange;
                const isHourlyRate = productType == EnumProductRateType.HoursPerUnit;
                const isUnitRate = productType == EnumProductRateType.UnitQtyRange;
                const isDailyRate = productType == EnumProductRateType.DayRange;

                return (
                  <>
                    <Col xs={12} md={6}>
                      <div className="mb-3">
                        <p className="m-0 p-0 mb-3 font-weight-bold" style={{ fontSize: "18px" }}><span className="">{item.unit.vendorUnit.unitName}</span></p>
                        <p className="m-0 p-0 mb-3 font-weight-bold" style={{ fontSize: "18px" }}>Net Rate $: <span className="red-text">{item.unit.net}</span></p>

                        <Row className="d-flex flex-row justify-content-start mb-3">
                          <div className="d-flex flex-column InputFromTo">
                            <Form.Label>
                              From Date
                            </Form.Label>
                            <CustomDayPickerInput
                              inputProps={{ disabled: true }}
                              // overlayComponent={MobileDayPickerOverlay}
                              value={moment(item.unit.fromDate).format("ddd, MMM Do, YYYY")}
                              placeholder="From"
                              format="LL"
                              formatDate={formatDate}
                              parseDate={parseDate}
                              dayPickerProps={{
                                selectedDays: [item.unit.fromDate],
                                // disabledDays: { before: datesAndGuests.fromDate, after: datesAndGuests.toDate },
                                // toMonth: item.checkOut,
                                // modifiers,
                                numberOfMonths: 1,
                                // onDayClick: () => this.to.getInput().focus(),
                              }}
                              onDayChange={(date: Date) => startDateChanged("custom", index, date)}
                            />
                          </div>
                          {rangePickerMode && (
                            <div className="d-flex flex-column InputFromTo " style={{ paddingLeft: "10px" }}>
                              <Form.Label>
                                To Date
                              </Form.Label>
                              <CustomDayPickerInput
                                inputProps={{ disabled: true }}
                                // overlayComponent={MobileDayPickerOverlay}
                                value={moment(item.unit.toDate).format("ddd, MMM Do, YYYY")}
                                placeholder="Check Out"
                                format="LL"
                                formatDate={formatDate}
                                parseDate={parseDate}
                                dayPickerProps={{
                                  selectedDays: [item.unit.toDate],
                                  // disabledDays: { before: moment(item.checkIn).toDate(), after: moment(item.checkOut).toDate() },
                                  // modifiers,
                                  numberOfMonths: 1
                                }}
                                onDayChange={(date: Date) => endDateChanged("custom", index, date)}
                              />
                            </div>
                          )}
                        </Row>
                        <Row className="d-flex flex-row justify-content-start mb-3">
                          <div className="d-flex flex-column">
                            <Form.Label>
                              From Time
                            </Form.Label>
                            <Form.Control
                              as="select"
                              name="startTime"
                              className="time-select"
                              style={{ width: "120px" }}
                              value={item.unit.fromTime}
                              onChange={(event: any) => { startTimeChanged("custom", index, event.currentTarget.value) }}
                            >

                              {startTimeOptions}
                            </Form.Control>
                          </div>

                          {/* To Time Select */}
                          {(isHourlyRate || isDailyRate) && (
                            <div className="d-flex flex-column pl-3">
                              <Form.Label>
                                To Time
                              </Form.Label>
                              <Form.Control
                                as="select"
                                name="endTime"
                                className="time-select"
                                style={{ width: "120px" }}
                                value={item.unit.toTime}
                                onChange={(event: any) => { endTimeChanged("custom", index, event.currentTarget.value) }}
                              >

                                {startTimeOptions}
                              </Form.Control>
                            </div>
                          )}

                          <div className="d-flex flex-column pl-3">
                            <Form.Label>
                              Units
                            </Form.Label>
                            <Form.Control
                              disabled
                              as="select"
                              name="units"
                              className="guest-select"
                              defaultValue={item.unit.units}
                              onChange={(event: any) => { unitsChanged("custom", index, event.currentTarget.value) }}
                            >
                              {getNumUnitsOptions()}
                            </Form.Control>
                          </div>
                        </Row>

                        <Form.Group as={Col} xs={12} >
                          <Form.Label>Confirmation Number</Form.Label>
                          <Row>
                            <Col xs={6} className="pr-3">
                              <Form.Control className=""
                                defaultValue={item.unit.confirmationNumber !== undefined ? item.unit.confirmationNumber : ""}
                                onChange={(e: any) => {
                                  item.unit.confirmationNumber = e.target.value;
                                }}
                                isInvalid={errors.unit !== undefined && errors.unit.id === item.unit.id}
                              />
                            </Col>
                            <Col xs={2}>
                              <Button variant="success" onClick={
                                () => {
                                  onSubmit("custom", item.unit);
                                }
                              }>{updateResponse.isLoading ? (
                                <span><Spinner
                                  as="span"
                                  animation="border"
                                  size="sm"
                                  role="status"
                                  aria-hidden="true"
                                /></span>
                              ) : "save"}</Button>
                            </Col>

                          </Row>
                          {/* <Form.Control.Feedback type="invalid">
          {"Required"}
        </Form.Control.Feedback> */}
                        </Form.Group>
                      </div>
                    </Col>
                    <br />
                  </>
                )
              }
              )}
            </Row>
          </Col>
        </Form>
      )}
    </div>
  );
}

export default VendorConfirmation